import React from "react";
import PropTypes from "prop-types";
import { CheckCircleOutlined, HighlightOffOutlined } from "@mui/icons-material";
import { Chip } from "@mui/material";

// Active/inactive chip that never relies on color alone — an icon plus text
// label carries the meaning so the state reads correctly for colorblind users
// and in text-only contexts (e.g. screen readers via the chip's accessible name).
const StatusChip = ({ isActive, size = "small" }) => (
  <Chip
    icon={
      isActive ? (
        <CheckCircleOutlined sx={{ fontSize: 14, color: "inherit !important" }} />
      ) : (
        <HighlightOffOutlined sx={{ fontSize: 14, color: "inherit !important" }} />
      )
    }
    label={isActive ? "Active" : "Inactive"}
    size={size}
    sx={{
      fontSize: "11px",
      fontWeight: 600,
      background: isActive ? "#e6f9f1" : "#f3f4f6",
      color: isActive ? "#1a7a4c" : "#6b7280",
      border: "1px solid",
      borderColor: isActive ? "#a2e2c3" : "#d1d5db",
    }}
  />
);

StatusChip.propTypes = {
  isActive: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium"]),
};

export default StatusChip;
